export default __webpack_public_path__ + "static/media/Shopping.22a1bcd8.svg";